import {firebaseOption} from "@/api/config";
import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import 'firebase/firestore'

import userInfo from './user/UserInfo'
import language from "./country/language";
import common from "./modules/common"

Vue.use(Vuex)

const firebaseConfig = firebaseOption;
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default new Vuex.Store({
  state: {
      db: firebase.firestore(),
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    userInfo,
    language,
    common
  }
})
